import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login({posting}) {
  const navigate=useNavigate()
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    address: ""
  });

  function handleSubmit(e) {
    e.preventDefault();
    console.log(formData);
    posting(formData)
    navigate('/home')
  }

  function handleChange(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  return (
    <form className="form" onSubmit={handleSubmit}>
      <p className="title">Register</p>
      <p className="message">Signup now and get full access to our app.</p>
      <div className="flex">
        <label>
          <input
            required
            placeholder=""
            type="text"
            className="input"
            name="name"
            onChange={handleChange}
          />
          <span>Name</span>
        </label>
      </div>

      <label>
        <input
          required
          placeholder=""
          type="email"
          className="input"
          name="email"
          onChange={handleChange}
        />
        <span>Email</span>
      </label>
      <label>
        <input
          type="address"
          className="input"
          name="address"
          onChange={handleChange}
        />
        <span>Address</span>
      </label>
      <button type="submit" className="submit">
        Submit
      </button>
    </form>
  );
}
